export enum Outlets {
  Primary = "primary",
  SideNav = "sidenav",
  Container = "container",
}
